module.exports = __webpack_public_path__ + "static/media/Jerome.671e2e37.png";